export const fullWidthToHalfWidth = (number: string) =>
    number.replace(/[０-９]/g, (digit) => String.fromCharCode(digit.charCodeAt(0) - 0xfee0));
